/** @jsxImportSource @emotion/react */
import {
  MenuItem as MuiMenuItem,
  TextField as MuiTextField,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Labels } from '@zip/business-components';
import * as Icons from '@zip/icons';
import { theme } from 'global';
import { FC, ReactNode } from 'react';
import { MultiSelectProps } from './MultiSelectProps';
import * as styles from './MultiSelect.styles';

const MultiSelect: FC<MultiSelectProps> = ({
  options,
  value = [],
  ...props
}) => {
  return (
    <MuiTextField
      select
      variant="outlined"
      label={props.label}
      value={value}
      css={styles.textField}
      {...props}
      slotProps={{
        inputLabel: {
          shrink: undefined,
        },
        select: {
          multiple: true,
          IconComponent: KeyboardArrowDownIcon,
          renderValue: (selected: unknown): ReactNode => {
            const values = Array.isArray(selected) ? selected : [];

            // IMPORTANT: return nothing when empty so MUI sees it as empty
            if (values.length === 0) return null;

            return (
              <div css={styles.renderValueContainer}>
                {values.map((valueToMap, i) => (
                  <Labels.Basic
                    key={`${String(valueToMap)}-${i}`}
                    variant="basic"
                    label={
                      options?.find(
                        (o) => String(o.value) === String(valueToMap)
                      )?.label
                    }
                    css={styles.labelChip}
                  />
                ))}
              </div>
            );
          },

          MenuProps: {
            MenuListProps: {
              disablePadding: true,
            },
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            transformOrigin: { vertical: 'top', horizontal: 'left' },
            disablePortal: false,
          },
        },
      }}
    >
      {options?.map((option) => (
        <MuiMenuItem
          key={option.value}
          value={option.value}
          css={styles.menuItem}
        >
          <div css={styles.checkboxBox}>
            <Icons.Check
              width="20"
              height="20"
              fill={
                value?.includes(option.value.toString())
                  ? theme.colors.primary.medium
                  : 'transparent'
              }
            />
          </div>

          {option.label}
        </MuiMenuItem>
      ))}
    </MuiTextField>
  );
};

export default MultiSelect;
